import currentOverviewMapService from "../api/server/currentOverviewMapService";
import errorHelper from "@/components/helpers/errorhelper";
export const CURRENT_OVERVIEW_MAP_NAMESPACE = "currentOverviewMapModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/currentOverviewMapService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(currentOverviewMapService)
};

const state = {
  clientData: [],
  originalData: []
};
const actions = {
  async LOAD_CLIENT_PACKAGES(context, clientIds) {
    var api = await services.api;
    return api.loadPackages(clientIds).then(function(value) {
      context.commit("SET_DATA", value);
    });
  },
  async LOAD_CLIENTS(context) {
    var api = await services.api;
    return api
      .loadClients(context)
      .then(function(value) {
        context.commit("SET_CLIENTS", value);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async EXPORT_DATA_TO_EXCEL(context, filteredData) {
    var api = await services.api;
    return api
      .getExcelDocument(filteredData)
      .then(function(value) {
        return value;
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  CLEAR_MARKERS(context) {
    context.commit("SET_DATA", []);
  }
};
const mutations = {
  SET_CLIENTS(storeState, clientData) {
    // AllianceRx contains Ids 3 & 4, locations need to be merged and only one client show
    let client3 = clientData.find(x => x.Id === 3);
    let client4 = clientData.find(x => x.Id === 4);
    /* istanbul ignore else */
    if (client3 && client4) {
      client3.Locations.forEach(loc => {
        client4.Locations.push(loc);
      });
    }
    var filteredClients = clientData.filter(x => {
      return x.Id !== 3;
    });

    storeState.clientData = filteredClients;
  },
  SET_DATA(storeState, data) {
    storeState.originalData = data;
    for (let i = 0; i < storeState.originalData.length; i++) {
      storeState.originalData[i].Detail.forEach(p => {
        if (p.ClientId === 3) p.ClientId = 4;
        if (!p.ContentsValue) p.ContentsValue = 0;
      });
      storeState.originalData[i].Id = "data-" + i;
    }
  }
};
const getters = {
  originalData: storeState => storeState.originalData,
  clientData: storeState => storeState.clientData
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
